import { Box, LinearProgress } from '@mui/material';
import { TimeoutId } from '@reduxjs/toolkit/dist/query/core/buildMiddleware/types';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

type PropsType = {
  duration: number;
  onCountDownEnd?: () => void;
  loop?: boolean;
};

export const CountDownAnimation = (props: PropsType) => {
  const { duration, onCountDownEnd, loop } = props;

  const progressTimer = useRef<TimeoutId>();
  const [progress, setProgress] = useState(0);
  const { iterationDuration, progressStep } = useMemo(() => {
    const iterationDuration = 400; // Animation speed
    const progressStep = duration / iterationDuration;

    return {
      iterationDuration,
      progressStep,
    };
  }, [duration]);

  const handleProgressInterval = useCallback(() => {
    setProgress((oldProgress) => {
      if (oldProgress === 100) {
        if (!!onCountDownEnd) {
          onCountDownEnd();
        }
        if (!!loop) {
          return 0;
        } else {
          clearInterval(progressTimer.current);
        }
      }
      return Math.min(oldProgress + progressStep, 100);
    });
  }, [setProgress, progressStep, loop, onCountDownEnd]);

  useEffect(() => {
    progressTimer.current = setInterval(
      handleProgressInterval,
      iterationDuration,
    );

    return () => {
      clearInterval(progressTimer.current);
    };
  }, [iterationDuration, handleProgressInterval]);

  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgress variant="determinate" value={progress} />
    </Box>
  );
};
